'use strict';

import angular from 'angular';
import routes from './physician.routes';
import PhysicianController from './physician.controller';
import PhysicianService from './physician.service';

export default angular.module('safestartServerApp.physician', ['safestartServerApp.auth', 'ui.router'])
  .config(routes)
  .factory('Physician', PhysicianService)
  .controller('PhysicianController', PhysicianController)
  .name;



// WEBPACK FOOTER //
// ./client/app/physician/index.js